import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HideShowScreenService {

  private menuVisibleSubject = new Subject<boolean>(); 
  private menuVisibleStateSubject = new BehaviorSubject<boolean>(false);
  public selectedTabSubject = new BehaviorSubject<number>(0); 

  menuVisible$ = this.menuVisibleSubject.asObservable();
  selectedTab$ = this.selectedTabSubject.asObservable();

  showMenu(tabId: number) {
    this.selectedTabSubject.next(tabId);
    this.menuVisibleStateSubject.next(false);
    this.menuVisibleSubject.next(true);
  }

  hideMenu() {
    this.menuVisibleStateSubject.next(true);
    this.menuVisibleSubject.next(false);
  }

  toggleMenu(currentVisible: boolean) {
    this.menuVisibleSubject.next(!currentVisible);
  }

  getSelectedState(): boolean {
    return this.menuVisibleStateSubject.getValue();
  }

  getSelectedTab(): number {
    return this.selectedTabSubject.getValue();
  }
}
